import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[libMaxLength]",
  standalone: true
})
export class MaxLengthDirective {
  @Input() appMaxLength: number = 10;

  @HostListener("input", ["$event"])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const { value } = input;

    if (value && value.length > this.appMaxLength) {
      input.value = value.substring(0, this.appMaxLength);
    }
  }

  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (this.el.nativeElement.value) {
      this.el.nativeElement.value = this.el.nativeElement.value.substring(0, this.appMaxLength);
    }
  }
}
